angular.module('app.core').factory('usuarioFeatureFactory', ['$http', function ($http) {

    var _apiName = 'SysUsuario';

    var _list = function (search, options) {
        var dto = options.data;
        dto.search = search;
        dto.parms = [];
        $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListUsuarioFeature', dto).then(function (response) {
            options.success(response.data);
        }, function (response) {
            options.error(response.data);
        });
    };

    var factory = {};

    factory.list = _list;

    return factory;

}]);
